import { render, staticRenderFns } from "./BasePageTeachingFeed.vue?vue&type=template&id=b3652498&"
import script from "./BasePageTeachingFeed.vue?vue&type=script&lang=js&"
export * from "./BasePageTeachingFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports